import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy
} from "@angular/core";
import { Router } from "@angular/router";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ProductQuantityInputComponent } from "../product-quantity-input/product-quantity-input.component";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { ProductService } from "src/app/core/services/product-service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-product-image",
  templateUrl: "./product-image.component.html",
  styleUrls: ["./product-image.component.css"],
})
export class ProductImageComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  @Input()
  public product: any;

  @Input()
  public stock: any;

  @Input()
  public showStock: boolean;

  @Input()
  public mostraPreco: boolean;

  @Input()
  public height: string;

  @Input()
  public produtoDescrHeight: string;

  @Output()
  public onAdd = new EventEmitter<number>();

  @Output()
  public redirectTo = new EventEmitter<number>();

  @ViewChild("productQuantityInput", {
    read: ProductQuantityInputComponent,
    static: true,
  })
  public productQuantityInput!: ProductQuantityInputComponent;

  public API_IMAGENS: string;
  public API_IMAGENS_PRODUTOS: string;
  public site: ConfiguracoesSite;
  public quantity: number;
  public rebate: number;

  constructor(private router: Router, private productService: ProductService) {
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.site = Configuracoes.SITE;
  }

  ngOnInit(): void {
    this.quantity = this.product.quantidade;
    this.rebate = this.product.desconto;
    console.log(this.product)
    this.subscriptions.add(
      this.productService.itemRemovedObservable$.subscribe((id: number) => {
        if (id === this.product.id) {
          this.updateQuantity(0);
        }
      })
    );

    this.subscriptions.add(
      this.productService.productQuantityUpdated$.subscribe(({ id, quantity }) => {
        if (id === this.product.id) {
          this.updateQuantity(quantity);
        }
      })
    );
  }

  public updateQuantity(quantity) {
    this.product.quantidade = quantity;
    if (this.productQuantityInput)
      this.productQuantityInput.updateQuantity(quantity);
    this.ngOnInit();
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
